// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-panel-options__size-div[data-v-3fa0f9ca]{width:44px}.image-panel-options__size-label[data-v-3fa0f9ca]{vertical-align:middle;font-size:12px;color:#161616;border-width:0;padding-left:12px}.image-panel-options__size[data-v-3fa0f9ca]{padding:0 15px 12px 5px;border-width:1px 0 0 0;border-style:solid;border-color:#d3d3d3;flex-direction:column;display:flex}.row[data-v-3fa0f9ca]{display:flex}", ""]);
// Exports
module.exports = exports;
